// This file is auto-generated by @hey-api/openapi-ts

import type { GetApiV1ClientsExternalByPersonalNumberResponse, GetApiV1ModelingModuleRunsByModuleRunIdResponse, GetApiV1ModelingModuleRunsResponse, GetApiV1ModelingPathsByPathRunIdResponse, GetApiV1ModelingPathsByPathRunIdVersionsResponse, GetApiV1ModelingPathsPublicByPublicShareTokenResponse, GetApiV1ModelingPathsResponse, GetApiV1PdfPathRenderResponse, GetApiV1UsersByUserIdResponse, GetApiV1UsersResponse } from './types.gen';

const userListItemDtoSchemaResponseTransformer = (data: any) => {
    data.dateCreated = new Date(data.dateCreated);
    return data;
};

const entityListOfUserListItemDtoSchemaResponseTransformer = (data: any) => {
    if (data.items) {
        data.items = data.items.map((item: any) => userListItemDtoSchemaResponseTransformer(item));
    }
    return data;
};

export const getApiV1UsersResponseTransformer = async (data: any): Promise<GetApiV1UsersResponse> => {
    data = entityListOfUserListItemDtoSchemaResponseTransformer(data);
    return data;
};

const userDetailDtoSchemaResponseTransformer = (data: any) => {
    if (data.lastSignInDate) {
        data.lastSignInDate = new Date(data.lastSignInDate);
    }
    return data;
};

export const getApiV1UsersByUserIdResponseTransformer = async (data: any): Promise<GetApiV1UsersByUserIdResponse> => {
    data = userDetailDtoSchemaResponseTransformer(data);
    return data;
};

const pathRunStepDtoSchemaResponseTransformer = (data: any) => {
    if (data.computedAt) {
        data.computedAt = new Date(data.computedAt);
    }
    return data;
};

const sharedPathRunDtoSchemaResponseTransformer = (data: any) => {
    data.steps = data.steps.map((item: any) => pathRunStepDtoSchemaResponseTransformer(item));
    return data;
};

export const getApiV1PdfPathRenderResponseTransformer = async (data: any): Promise<GetApiV1PdfPathRenderResponse> => {
    data = sharedPathRunDtoSchemaResponseTransformer(data);
    return data;
};

const pathRunListItemDtoSchemaResponseTransformer = (data: any) => {
    data.dateCreated = new Date(data.dateCreated);
    if (data.dateUpdated) {
        data.dateUpdated = new Date(data.dateUpdated);
    }
    return data;
};

const entityListOfPathRunListItemDtoSchemaResponseTransformer = (data: any) => {
    if (data.items) {
        data.items = data.items.map((item: any) => pathRunListItemDtoSchemaResponseTransformer(item));
    }
    return data;
};

export const getApiV1ModelingPathsResponseTransformer = async (data: any): Promise<GetApiV1ModelingPathsResponse> => {
    data = entityListOfPathRunListItemDtoSchemaResponseTransformer(data);
    return data;
};

const pathRunDetailDtoSchemaResponseTransformer = (data: any) => {
    if (data.clientBirthDate) {
        data.clientBirthDate = new Date(data.clientBirthDate);
    }
    data.steps = data.steps.map((item: any) => pathRunStepDtoSchemaResponseTransformer(item));
    data.dateCreated = new Date(data.dateCreated);
    if (data.dateUpdated) {
        data.dateUpdated = new Date(data.dateUpdated);
    }
    return data;
};

export const getApiV1ModelingPathsByPathRunIdResponseTransformer = async (data: any): Promise<GetApiV1ModelingPathsByPathRunIdResponse> => {
    data = pathRunDetailDtoSchemaResponseTransformer(data);
    return data;
};

export const getApiV1ModelingPathsPublicByPublicShareTokenResponseTransformer = async (data: any): Promise<GetApiV1ModelingPathsPublicByPublicShareTokenResponse> => {
    data = sharedPathRunDtoSchemaResponseTransformer(data);
    return data;
};

const pathRunVersionListItemDtoSchemaResponseTransformer = (data: any) => {
    data.dateCreated = new Date(data.dateCreated);
    if (data.dateUpdated) {
        data.dateUpdated = new Date(data.dateUpdated);
    }
    return data;
};

export const getApiV1ModelingPathsByPathRunIdVersionsResponseTransformer = async (data: any): Promise<GetApiV1ModelingPathsByPathRunIdVersionsResponse> => {
    data = data.map((item: any) => pathRunVersionListItemDtoSchemaResponseTransformer(item));
    return data;
};

const moduleRunListItemDtoSchemaResponseTransformer = (data: any) => {
    if (data.computedAt) {
        data.computedAt = new Date(data.computedAt);
    }
    data.dateCreated = new Date(data.dateCreated);
    if (data.dateUpdated) {
        data.dateUpdated = new Date(data.dateUpdated);
    }
    return data;
};

const entityListOfModuleRunListItemDtoSchemaResponseTransformer = (data: any) => {
    if (data.items) {
        data.items = data.items.map((item: any) => moduleRunListItemDtoSchemaResponseTransformer(item));
    }
    return data;
};

export const getApiV1ModelingModuleRunsResponseTransformer = async (data: any): Promise<GetApiV1ModelingModuleRunsResponse> => {
    data = entityListOfModuleRunListItemDtoSchemaResponseTransformer(data);
    return data;
};

const moduleRunDetailDtoSchemaResponseTransformer = (data: any) => {
    if (data.clientBirthDate) {
        data.clientBirthDate = new Date(data.clientBirthDate);
    }
    if (data.computedAt) {
        data.computedAt = new Date(data.computedAt);
    }
    data.dateCreated = new Date(data.dateCreated);
    if (data.dateUpdated) {
        data.dateUpdated = new Date(data.dateUpdated);
    }
    return data;
};

export const getApiV1ModelingModuleRunsByModuleRunIdResponseTransformer = async (data: any): Promise<GetApiV1ModelingModuleRunsByModuleRunIdResponse> => {
    data = moduleRunDetailDtoSchemaResponseTransformer(data);
    return data;
};

const sabIdentityCardDtoSchemaResponseTransformer = (data: any) => {
    if (data.validFrom) {
        data.validFrom = new Date(data.validFrom);
    }
    if (data.validTo) {
        data.validTo = new Date(data.validTo);
    }
    return data;
};

const sabClientInfoDtoSchemaResponseTransformer = (data: any) => {
    if (data.birthDate) {
        data.birthDate = new Date(data.birthDate);
    }
    if (data.companyRegistrationDate) {
        data.companyRegistrationDate = new Date(data.companyRegistrationDate);
    }
    return data;
};

const sabClientAssignmentDtoSchemaResponseTransformer = (data: any) => {
    if (data.assigned) {
        data.assigned = sabClientDetailDtoSchemaResponseTransformer(data.assigned);
    }
    return data;
};

const sabClientDetailDtoSchemaResponseTransformer = (data: any) => {
    if (data.identityCard) {
        data.identityCard = sabIdentityCardDtoSchemaResponseTransformer(data.identityCard);
    }
    if (data.clientInfo) {
        data.clientInfo = sabClientInfoDtoSchemaResponseTransformer(data.clientInfo);
    }
    data.clientAssignments = data.clientAssignments.map((item: any) => sabClientAssignmentDtoSchemaResponseTransformer(item));
    return data;
};

export const getApiV1ClientsExternalByPersonalNumberResponseTransformer = async (data: any): Promise<GetApiV1ClientsExternalByPersonalNumberResponse> => {
    data = sabClientDetailDtoSchemaResponseTransformer(data);
    return data;
};
